/* Progressive enhancement only: native variant controls, cart and checkout remain authoritative. */
(() => {
  'use strict';
  if (customElements.get('armadox-boot-choice')) return;
  class ArmadoxBootChoice extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.product = this.closest('product-info');
      if (!this.product) return;
      try {
        this.variants = JSON.parse(this.querySelector('[data-boot-variants]').textContent);
        this.options = JSON.parse(this.querySelector('[data-boot-options]').textContent);
      } catch { return; }
      this.summary = this.querySelector('[data-boot-summary]');
      this.advice = this.querySelector('[data-boot-advice]');
      this.sizeIndex = this.options.findIndex(name => /pointure|shoe size|size|taille/i.test(name));
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      // The theme emits input change when its server-rendered variant response arrives.
      this.product.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.render(event.target.value);
      }, options);
      // Sticky purchase controls emit the same theme event. Ignore other products/quick views.
      document.addEventListener('variant:changed', event => {
        const id = event.detail?.variant?.id;
        const input = this.product.querySelector('product-form input[name="id"]');
        if (id && String(input?.value) === String(id)) this.render(id);
      }, options);
      this.render(this.dataset.selectedId);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    render(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      this.summary.replaceChildren();
      this.summary.hidden = !variant;
      let selected = '';
      if (variant) {
        selected = variant.options.map((value,index) => index === this.sizeIndex ? `Pointure ${value}` : value).join(' · ');
        const selection = document.createElement('strong');
        selection.textContent = `Votre sélection : ${selected}`;
        this.summary.append(selection);
        const stockNeedsAdvice = variant.available && variant.tracked && variant.quantity <= 0;
        this.dataset.state = !variant.available ? 'unavailable' : stockNeedsAdvice ? 'check' : 'available';
        if (!variant.available || stockNeedsAdvice) {
          const note = document.createElement('p');
          note.textContent = stockNeedsAdvice
            ? 'Disponibilité à confirmer : demandez conseil avant de commander cette pointure.'
            : 'Cette combinaison couleur / pointure est indisponible.';
          this.summary.append(note);
          const alternatives = this.sizeIndex < 0 ? [] : this.variants.filter(v =>
            v.available && (!v.tracked || v.quantity > 0) &&
            v.options.every((value,index) => index === this.sizeIndex || value === variant.options[index])
          ).map(v => v.options[this.sizeIndex]);
          if (alternatives.length) {
            const sizes = document.createElement('p');
            sizes.textContent = `Pointures disponibles dans ce coloris : ${[...new Set(alternatives)].sort((a,b)=>a.localeCompare(b,'fr',{numeric:true})).join(', ')}. Choisissez uniquement votre pointure.`;
            this.summary.append(sizes);
          }
        }
      }
      const link = new URL('https://api.whatsapp.com/send');
      link.searchParams.set('phone','212708778881');
      link.searchParams.set('text',`Bonjour ARMADOX, je souhaite un conseil pour ${this.dataset.productTitle}${selected ? ` — ${selected}` : ''}. Ma pointure habituelle est : … ${this.dataset.productUrl}${variant ? `?variant=${variant.id}` : ''}`);
      this.advice.href = link.href;
    }
  }
  customElements.define('armadox-boot-choice', ArmadoxBootChoice);
})();
